import React, { useEffect } from "react";
import Hero from "../components/Home/Hero";
import Aboutus from "../components/Home/Aboutus";
import Room from "../components/Home/Room";
import Offer from "../components/Home/Offer";
import Services from "../components/Home/Services";
import Testimonials from "../components/Home/Testimonials";
import Blogs from "../components/Home/Blogs";
import { useAppDispatch, useAppSelector } from "../Hooks";
import { getHomeData } from "../features/home";
import { Loader } from "../components/common/Loader";


const Home: React.FC = () => {
    const dispatch = useAppDispatch();
    const { menu } = useAppSelector(state => state.menuAccess);
    console.log(menu, 'menu');
    const { home_data, room_types, testimonials, articles, special_offers, our_services, amenities, homeLoader } = useAppSelector(state => state.home);
    useEffect(() => {
        dispatch(getHomeData());
    }, [dispatch]);


    if (homeLoader) {
        <Loader />
    }
    const { home_sections } = menu?.home || {};
    return (
        <>
            {
                home_sections && home_sections?.hero &&
                <Hero />
            }  
            {
                home_sections && home_sections?.aboutus &&

                <Aboutus home_data={home_data} />
            }
            {
                home_sections && home_sections?.room &&

                <Room home_data={home_data} room_types={room_types} />
            }
            {
                home_sections && home_sections?.offer &&

                <Offer special_offers={special_offers} />
            }
            {
                home_sections && home_sections?.services &&

                <Services our_services={our_services} />
            }
            {
                home_sections && home_sections?.testimonials &&

                <Testimonials testimonials={testimonials} amenities={amenities} />
            }
            {
                home_sections && home_sections?.blogs &&

                <Blogs articles={articles} />
            }
        </>
    )
}
export default Home;